import React, { useRef } from 'react'

const useDebounce = () => {
    const debounceRef = useRef();

    const debounce = (callback, delay) => {
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }
        debounceRef.current = setTimeout(callback, delay);
    }
    
    return debounce;
}

export default useDebounce